<div class="container">
  <rt-box layout-vertical variant="raised-higher no-padding">
    Token: {{ token }}
    <rt-form-field>
      <rt-label>Email</rt-label>
      <rt-input type="text"> </rt-input>
    </rt-form-field>
    <rt-form-field>
      <rt-label>Password</rt-label>
      <rt-input type="password"> </rt-input>
    </rt-form-field>
    <rt-button variant="primary" (click)="signIn()"> Sign in </rt-button>
  </rt-box>
</div>
